import {connect} from 'react-redux';

import {globalNamespace} from '../../../helpers/models/namespaceHelpers';
import {
  makeMapDispatchToProps,
  makeMapStateToProps,
  wrapInShallowSelector,
} from '../../../helpers/reselectHelpers';
import {CardModel, CardTypesEnum} from '../../../models/api/cardModel';
import {VisualContactModel} from '../../../models/api/visualContactModel';
import {ThunkAction} from '../../../store/appThunk';
import {updateAccountDetailsSectionExpandedAction} from '../../../store/data/localPreferences/localPreferencesActions';
import {getAccountDetailsSectionsExpandState} from '../../../store/data/localPreferences/localPreferencesSelectors';
import {
  contactDetailsCreateAccountFormAction,
  createCardAndUpdateContactDetailsPanelAction,
} from '../../../store/panels/contacts/contactDetailsPanelActions';
import {ContactDetailsCreateAccountSourceActionsEnum} from '../../../store/panels/contacts/contactDetailsPanelSubState';
import {ContactDetailsPanelId} from '../../../store/panels/panelStateBase';
import {ContactDetailsNoAccountCustomDomain} from './contactDetailsNoAccountCustomDomain';

/*
 * Props.
 */

interface ContactDetailsNoAccountCustomDomainContainerProps {
  panelId: ContactDetailsPanelId;
  card: CardModel | undefined;
  contact: VisualContactModel | undefined;
  customDomain: string;
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps()(() => ({
  sectionExpandState: wrapInShallowSelector(getAccountDetailsSectionsExpandState),
}));

const mapDispatchToProps = makeMapDispatchToProps<ContactDetailsNoAccountCustomDomainContainerProps>()(
  (props) => ({
    onAccountDetailsSectionToggled: updateAccountDetailsSectionExpandedAction,
    createNewAccount: (): ThunkAction => async (dispatch) => {
      const {card, contact, panelId, customDomain} = props;

      if (!contact) {
        return;
      }

      // If we do not have a card, we need to create a card first
      const selectedCard =
        card ??
        (await dispatch(
          createCardAndUpdateContactDetailsPanelAction(
            panelId,
            {
              namespace: globalNamespace,
              name: contact.name || contact.contact.handle,
              contacts: [contact.contact],
              type: CardTypesEnum.AUTO,
            },
            true,
          ),
        ));

      // TODO: Show an error to the user that we failed to create/find a card
      if (!selectedCard) {
        return;
      }

      dispatch(
        contactDetailsCreateAccountFormAction(
          panelId,
          ContactDetailsCreateAccountSourceActionsEnum.CONTACT_DETAILS,
          selectedCard.id,
          customDomain.split('.')[0],
          customDomain,
        ),
      );
    },
  }),
);

export const ContactDetailsNoAccountCustomDomainContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ContactDetailsNoAccountCustomDomain);
